import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-4" }
const _hoisted_5 = { class: "d-flex justify-content-between h4 pb-2 mb-4 text-danger border-bottom border-danger" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cart-check-fill fs-2 text-white me-2" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "d-flex gap-4"
}
const _hoisted_9 = { class: "d-flex gap-4" }
const _hoisted_10 = { class: "d-flex gap-4" }
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h4 pb-2 mb-4 pb-6 text-danger border-bottom border-danger" }, "Detalle", -1)
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4 cursor-pointer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DialogEditItemDetail = _resolveComponent("DialogEditItemDetail")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "lock-scroll": "",
    draggable: "",
    "destroy-on-close": "",
    fullscreen: true
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, [
                      _createTextVNode("Orden "),
                      (_ctx.itemOrder?.idorder)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(`${_ctx.form?.status?.params} ms-2`)
                          }, _toDisplayString(_ctx.form?.status?.name), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        round: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.itemOrder?.idorder ? 'Actualizar' : 'Guardar'), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "idcomprobante",
                    label: 'Comprobante',
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idcomprobante,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idcomprobante) = $event)),
                        placeholder: "Select"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listComprobantes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  (_ctx.userAccount?.idperfil == 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_el_form_item, {
                          prop: "idserie",
                          label: 'Serie',
                          rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.idserie,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.idserie) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]),
                        _createVNode(_component_el_form_item, {
                          prop: "idcorrelative",
                          label: 'Correlativo',
                          rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.idcorrelative,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.idcorrelative) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    prop: "document",
                    label: 'Documento',
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.document,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.document) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_el_form_item, {
                    prop: "customer",
                    label: 'Cliente',
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.customer,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.customer) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    label: 'Email',
                    rules: [{ required: false, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_form_item, {
                      prop: "payment_method",
                      label: 'Método de pago',
                      rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.payment_method,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.payment_method) = $event)),
                          placeholder: "Select"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPaymentMethods, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_el_form_item, {
                      prop: "payment_references",
                      label: 'Referencia de pago',
                      rules: [{ required: false, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.payment_references,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.payment_references) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_form_item, {
                      prop: "payment_currency",
                      label: 'Moneda',
                      class: "w-50",
                      rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.payment_currency,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.payment_currency) = $event)),
                          placeholder: "Select"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPaymentCurrencies, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    (_ctx.userAccount?.idperfil == 7 || _ctx.userAccount?.idperfil == 1 || _ctx.userAccount?.idperfil == 8)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "mstatus.id",
                          label: 'Estado',
                          class: "w-50",
                          rules: [{ required: false, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.form.mstatus,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.mstatus) = $event)),
                              placeholder: "Select"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: `lst-${item.id}`,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.listDetails,
                    height: 500,
                    border: "",
                    "table-layout": 'auto',
                    "scrollbar-always-on": false,
                    "highlight-current-row": "",
                    "show-summary": "",
                    "summary-method": _ctx.getSummaries
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "iddetails",
                        label: "ID",
                        width: "80",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "desc1",
                        label: "COMPETITOR",
                        width: "300",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "desc2",
                        label: "FUNCION",
                        width: "180",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "desc3",
                        label: "CATEGORIA",
                        width: "200",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "price",
                        label: 'CANT. PEN',
                        width: "110",
                        fixed: "right"
                      }, {
                        default: _withCtx(( {row} ) => [
                          _createElementVNode("span", null, _toDisplayString(row.price), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: 'Opcion',
                        fixed: "right"
                      }, {
                        default: _withCtx(( {row, $index} ) => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("i", {
                              class: "bi bi-pencil fs-2 text-hover-danger me-4 cursor-pointer",
                              onClick: ($event: any) => (_ctx.editItem(row,  $index))
                            }, null, 8, _hoisted_14),
                            _createVNode(_component_el_popconfirm, {
                              title: `${_ctx.t('delete')} ${row.desc1}?`,
                              width: "220",
                              "confirm-button-text": "SI",
                              onConfirm: ($event: any) => (_ctx.deleteItemDetails(row))
                            }, {
                              reference: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 2
                            }, 1032, ["title", "onConfirm"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "summary-method"])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_DialogEditItemDetail, {
        ref: "DialogEditItemDetailRef",
        "item-details": _ctx.itemDetails,
        onOnUpdateItemOrderDetails: _ctx.onUpdateItemOrderDetails
      }, null, 8, ["item-details", "onOnUpdateItemOrderDetails"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}